import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import {
  FaultReportRequest,
  FaultReportResult,
} from './fault-report.interface';

/**
 * Repair Dispatch: broken-charger fault reports.
 * The auth interceptor attaches the Firebase token, so these are login-only.
 */
@Injectable({
  providedIn: 'root',
})
export class FaultService {
  constructor(private http: HttpClient) {}

  /** Submit a broken-charger report. Returns the report plus its (updated) case. */
  reportFault(data: FaultReportRequest) {
    return this.http.post<FaultReportResult>(
      `${environment.api.repair}/fault/report`,
      data,
    );
  }
}
